module.exports = __webpack_public_path__ + "static/media/diageo.84320f03.mp4";